
import { defineComponent, PropType } from 'vue'

import { maska } from 'maska'
import { ErrorObject } from '@vuelidate/core'

import useValidationMessages from '@/common/composable/useValidationMessages'

export default defineComponent({
    name: 'new-input',
    directives: {
        maska,
    },
    props: {
        autocomplete: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: null,
        },
        maska: {
            type: Object,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        freeze: {
            type: Boolean,
            default: false,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
        name: {
            type: String,
            default: null,
        },
        hint: {
            type: String,
            default: null,
        },
        iconRightClickable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change', 'click-icon-right'],
    setup(props, { emit }) {
        const emitInput = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('update:value', target.value)
        }

        const emitChange = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('change', target.value)
        }

        const emitClickIconRight = (event: Event) => {
            emit('click-icon-right', event)
        }

        const { getValidationMessage } = useValidationMessages()

        return { emitInput, emitChange, getValidationMessage, emitClickIconRight }
    },
})
